<div class="container">
    <div class="about-chessx">
        <h1>About ChessX</h1>
        <p>Welcome to ChessX, your ultimate destination for all things chess! Whether you're a seasoned grandmaster or just starting your journey in the world of chess, ChessX has something for everyone. Our platform is designed to enhance your chess experience with a variety of features and resources.</p>
      
        <h2>What We Offer</h2>
        <div class="offerings">
          <section>
            <h3>Chess Puzzles</h3>
            <p>Sharpen your skills with our extensive collection of chess puzzles. From simple checkmates to complex tactical challenges, our puzzles cater to all skill levels and help improve your strategic thinking.</p>
          </section>
      
          <section>
            <h3>Play Online</h3>
            <p>Challenge players from around the world in our online chess arena. Whether you prefer casual games or competitive matches, you’ll find opponents at every level to match your skills and preferences.</p>
          </section>
      
          <section>
            <h3>Play with Friends</h3>
            <p>Connect with your friends and play chess in a private, enjoyable setting. Our platform makes it easy to invite and play with your friends, making every game a memorable experience.</p>
          </section>
      
          <section>
            <h3>Chess Openings</h3>
            <p>Explore and master various chess openings with our comprehensive library. Learn the best strategies and counter-strategies for each opening, enhancing your game from the very first move.</p>
          </section>
        </div>
      
        <h3>Our Mission</h3>
        <p>At ChessX, our mission is to foster a vibrant and inclusive chess community where players of all levels can come together to learn, play, and grow. We believe in the power of chess to challenge the mind and bring people together, and we are dedicated to providing the best tools and resources to support your chess journey.</p>
      
        <h3>Join Us Today!</h3>
        <p>Become a part of the ChessX community and take your chess game to the next level. Whether you're looking to improve your skills, compete with others, or simply enjoy the game with friends, ChessX is here for you. Join us today and start your chess adventure!</p>
      </div>
</div>

  